import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { Rating } from "@lomarengas/design-system";
import {
  AccommodationDetailsBasic,
  getAccommodationAddonsAsync,
  getAccommodationAttributesAsync,
  getAllAccommodationAttributesAsync,
  selectAccommodationAddons,
  selectAccommodationAddonsLoadingStatus,
  selectAccommodationAttributes,
  selectAccommodationAttributesLoadingStatus,
} from "./accommodationSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectInputErrors } from "../../features/errors/errorsSlice";
import { useAuthUser } from "../../features/auth/authHooks";

const AccommodationAddons = ({
  accommodationDetailsBasic,
}: {
  accommodationDetailsBasic: AccommodationDetailsBasic;
}) => {
  const { isOwnerUser } = useAuthUser();
  const inputErrors = useAppSelector(selectInputErrors);
  const accommodationAddonsLoadingStatus = useAppSelector(
    selectAccommodationAddonsLoadingStatus,
  );
  const accommodationAddons = useAppSelector(selectAccommodationAddons);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getAccommodationAddonsAsync(accommodationDetailsBasic.id));
  }, []);
  const accommodationAddOnItems = accommodationAddons?.map((item) => {
    if (item.name !== "not allowed item") {
      return (
        <tr key={item.id || item.name}>
          <td>{item.name}</td>
          {isOwnerUser && (
            <>
              <td>{item.price} €</td>
              <td>{item.purchasePrice} €</td>
            </>
          )}
        </tr>
      );
    }
    return null;
  });

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th scope="col" className="col-4">
              Lisäpalvelu
            </th>
            {isOwnerUser && (
              <>
                <th scope="col">Myyntihinta</th>
                <th scope="col">Tilityshinta</th>
              </>
            )}
          </tr>
        </thead>

        <tbody>{accommodationAddOnItems}</tbody>
      </table>
    </>
  );
};

export default AccommodationAddons;
export { AccommodationAddons };
